import Modal from "react-bootstrap/Modal";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import QRCode from "react-qr-code";
import Navbar from "react-bootstrap/Navbar";
import companyImage from "../images/customer-logo.png";

export const ViewQRCode = (props) => {
  function applyPrintStyles() {
    const style = document.createElement("style");
    style.textContent = `
           @media print {
               .qr-code {
                    .qr-code-navbar button{
                    float: right;
                    right: 10px;
                    }
                .card {
                    img {
                    height: 140px;
                    border-bottom: 1px solid #0047ab;
                    }
                    margin:10px;
                    .card-title {
                    text-align:center;
                    position: relative;
                    color:#0047ab;
                    font-weight: 700;
                    }
                    .user-role {
                    text-align:center;
                    position: relative;
                    }
                    .user-qr-code {
                    //left: 23%;
                    position: relative;
                    margin-left: auto;
                    margin-right: auto;
                    width: 50%;
                    display: table;
                    }
                }
                }
            @page {
                size: A4 portrait; /* Ensure A4 size and portrait orientation */
                margin: 10mm; /* Adjust margin if necessary */
              }
            }
        `;
    document.head.appendChild(style);
  }

  window.onbeforeprint = applyPrintStyles;

  //   const printModalContent = () => {
  //     const printWindow = window.open("", "", "height=842,width=1295");
  //     const modalContent = document.getElementById("printable-area").innerHTML;
  //     printWindow.document.write("<html><head><title>Print</title>");
  //     printWindow.document.write(
  //       '<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">'
  //     );
  //     printWindow.document.write("<style>");
  //     printWindow.document.write(`
  //             @media print {
  //                .qr-code {
  //                     .qr-code-navbar button{
  //                     float: right;
  //                     right: 10px;
  //                     }
  //                 .card {
  //                     img {
  //                     height: 140px;
  //                     border-bottom: 1px solid #0047ab;
  //                     }
  //                     margin:10px;
  //                     .card-title {
  //                     text-align:center;
  //                     position: relative;
  //                     color:#0047ab;
  //                     font-weight: 700;
  //                     }
  //                     .user-role {
  //                     text-align:center;
  //                     position: relative;
  //                     }
  //                     .user-qr-code {
  //                     //left: 23%;
  //                     position: relative;
  //                     margin-left: auto;
  //                     margin-right: auto;
  //                     width: 50%;
  //                     display: table;
  //                     }
  //                 }
  //                 }
  //             @page {
  //                 size: A4 portrait; /* Ensure A4 size and portrait orientation */
  //                 margin: 10mm; /* Adjust margin if necessary */
  //               }
  //             }
  //           `);
  //     printWindow.document.write("</style>");
  //     printWindow.document.write("</head><body >");
  //     printWindow.document.write(modalContent);
  //     printWindow.document.write("</body></html>");
  //     printWindow.document.close();
  //     printWindow.focus();
  //     printWindow.print();
  //   };

  const printModalContent = () => {
    const printWindow = window.open("", "", "height=842,width=1295");
    const modalContent = document.getElementById("printable-area").innerHTML;

    printWindow.document.write("<html><head><title>Print</title>");
    printWindow.document.write(
      '<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">'
    );
    printWindow.document.write("<style>");
    printWindow.document.write(`
      @media print {
        .card {
            margin: 10px;
        }
        img {
            height: 120px;
            border-bottom: 1px solid #0047ab;
        }
        .card-body{
            padding-bottom:0px;
        }
        .card-title {
            text-align: center;
            color: #0047ab;
            font-weight: 700;
        }
        .card-text{
            text-align: center;
             margin:0px
        }
        h6{
            text-align: center;
        }       
        .user-qr-code {
        }
      }
      @page {
        size: A4 portrait;
        margin: 5mm;
      }
    `);
    printWindow.document.write("</style>");
    printWindow.document.write("</head><body>");
    printWindow.document.write(modalContent);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-90w"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          View All QR Codes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="qr-code">
        <Navbar expand="lg" className="qr-code-navbar">
          <Button
            class="accordion-button"
            type="button"
            variant="primary"
            onClick={printModalContent}
          >
            <i className="bi bi-printer"></i> {"Print"}
          </Button>
        </Navbar>
        <div id="printable-area">
          <Row>
            {props.selectedItems.map((value, index) => (
              <Col xs={12} sm={6} md={4} lg={3} key={index} className="mb-4">
                <Card>
                  <Card.Img variant="top" src={companyImage} />
                  <Card.Body>
                    <Card.Title>{`${value.firstName}  ${value.lastName}`}</Card.Title>
                    <Card.Text>
                      <span className="user-role">
                        {" "}
                        <h6>{value.category} -  {value.userId}</h6>
                      </span>{" "}
                      <br />
                      <span className="user-qr-code d-flex justify-content-center align-items-center">
                        <QRCode size={160} value={value.userId} />
                      </span>
                      <br />
                      <br />
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};
